import axios from "@/api/axiosInstance";

export function uploadCSV(payload) {
  return axios.post(`/api/v1/csv/upload-file`, payload);
}
